import { Checkbox } from "antd";
import { FC } from "react";
import { SalesByPointInvoice } from "tm-shared/types";

import { SecondaryText } from "@/shared/ui/Typography";

import { StyledSBMRaw } from "../../Styled";

interface InvoiceFlagsProps {
    invoice: SalesByPointInvoice;
}

export const InvoiceFlags: FC<InvoiceFlagsProps> = ({ invoice }) => {
    if (!invoice?.isCarrier && !invoice?.isSelfDelivery) {
        return null;
    }

    return (
        <StyledSBMRaw $columns={1}>
            {invoice?.isCarrier && (
                <Checkbox checked disabled>
                    <SecondaryText fontSize={14}>
                        Відвантаження із залишків ТА (багажник)
                    </SecondaryText>
                </Checkbox>
            )}

            {invoice?.isSelfDelivery && (
                <Checkbox checked disabled>
                    <SecondaryText fontSize={14}>
                        Самостійний вивіз ТТ
                    </SecondaryText>
                </Checkbox>
            )}
        </StyledSBMRaw>
    );
};
